import { render, staticRenderFns } from "./tableDetailPenilaian.vue?vue&type=template&id=7ec13375&"
import script from "./tableDetailPenilaian.vue?vue&type=script&lang=js&"
export * from "./tableDetailPenilaian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports